import { render, staticRenderFns } from "./scope-editable.vue?vue&type=template&id=880a2d5c&scoped=true"
import script from "./scope-editable.vue?vue&type=script&lang=js"
export * from "./scope-editable.vue?vue&type=script&lang=js"
import style0 from "./scope-editable.vue?vue&type=style&index=0&id=880a2d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880a2d5c",
  null
  
)

export default component.exports